import { useGlobalContext } from "../../../context/GlobalContext";
import { getIcon } from "../../../utils/iconConfig";

const ArticleComponent = ({ ArticleData, type, handleClose }) => {
  const { setInfoFilter } = useGlobalContext();

  const rhodiumLabelMap = { W: "White", P: "Pink", Y: "Yellow" };

  const formatLabel = (item) => {
    if (type === "Gold karat")
      return `${item?.GoldQuantity}-${item?.goldColor}`;
    if (type === "Diamond Quality")
      return item["Diamond Quality"].replace(/=/g, "-");
    if (type === "Rhodium")
      return rhodiumLabelMap[item?.rhodium] || item?.rhodium;
    return "";
  };

  const getFilterValue = (item) => {
    if (type === "Rhodium") return `RH-${item?.rhodium}`;
    return formatLabel(item);
  };

  return (
    <>
      <div style={{ marginTop: "1.2vw", marginBottom: "1.2vw" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            rowGap: "1.4vw",
            columnGap: "1.8vw",
            alignItems: "center",
          }}
        >
          {ArticleData?.map((item, index) => (
            <div
              key={index}
              style={{
                fontFamily: "Poppins",
                fontWeight: 700,
                fontSize: ".7vw",
                lineHeight: "100%",
                letterSpacing: "0%",
              }}
            >
              <div style={{ display: "flex", gap: ".2vw" }}>
                {item?.goldColor && (
                  <span>
                    {getIcon(`GoldBarIconInfo`, `${item?.goldColor}`)}
                  </span>
                )}
                {type === "Rhodium" && (
                  <span>
                    {getIcon(`GoldBarIconInfo`, `${item?.rhodium}`)}
                  </span>
                )}
                <span>{formatLabel(item)}</span>
                <span> : </span>
                <span
                  style={{
                    fontSize: ".7vw",
                    color: "#50C878",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setInfoFilter(getFilterValue(item));
                    handleClose();
                  }}
                >
                  {item?.ArticleCount} Article
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default ArticleComponent;
